import { ContentBlockIntroCopyCentered } from '@dfh-corp-sites/ui'
import React from 'react'

import { Maybe, SanityContact } from '../../../groq/sanity-dispensaries/types'

type Props = {
  blurb?: Maybe<SanityContact['blurb']>
}

// The Introduction component displays the dispensary's blurb
const Introduction = ({ blurb }: Props) => {
  return <ContentBlockIntroCopyCentered content={blurb ?? ''} />
}

export { Introduction }
